import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationExplanation',
  emits: ["showCalcs"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

function onClick() {
    emit('showCalcs');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "btn-calculation position-absolute bottom-0 end-0 m-5 border border-primary",
    onClick: onClick
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("i", { class: "bi bi-currency-pound currencySymbol" }, null, -1),
    _createElementVNode("i", { class: "bi bi-gear-fill text-primary cog" }, null, -1),
    _createElementVNode("span", { class: "visually-hidden" }, "Show calculation details", -1)
  ])))
}
}

})